// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ConsultarProcesso, ConsultarProcessoRequest } from './types';

export function consultarProcessoRequest(
	token: string,
	data: ConsultarProcessoRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PROCESSO_REQUEST,
		token,
		payload: data,
	};
}
export function consultarProcessoSuccess(
	payload: ConsultarProcesso,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PROCESSO_SUCCESS,
		payload,
	};
}
export function consultarProcessoFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PROCESSO_FAILURE,
		payload: null,
	};
}
export function consultarProcessoClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PROCESSO_CLEAR,
		payload: null,
	};
}
